import { Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SortOption } from '../hooks/useOfferSort';

interface Props {
  value: SortOption;
  onChange: (value: SortOption) => void;
}

export const OfferSortSelect: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Select
      value={value}
      onChange={onChange}
      style={{ width: 280 }}
      options={[
        { value: 'lastModified-desc', label: t('PORTFOLIO.SORT.LAST_MODIFIED_DESC') },
        { value: 'lastModified-asc', label: t('PORTFOLIO.SORT.LAST_MODIFIED_ASC') },
        { value: 'createdAt-desc', label: t('PORTFOLIO.SORT.CREATED_AT_DESC') },
        { value: 'createdAt-asc', label: t('PORTFOLIO.SORT.CREATED_AT_ASC') },
        { value: 'price-asc', label: t('PORTFOLIO.SORT.PRICE_ASC') },
        { value: 'price-desc', label: t('PORTFOLIO.SORT.PRICE_DESC') },
      ]}
    />
  );
};
